(function () {
  const roots = document.querySelectorAll('[data-or-vehicle-selector]');
  if (!roots.length) return;

  window.dataLayer = window.dataLayer || [];

  const normalKey = (value) =>
    String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .replace(/\s+/g, ' ')
      .toLowerCase();

  function flatten(value) {
    if (value === null || value === undefined || value === '') return [];
    if (Array.isArray(value)) return value.flatMap(flatten);
    if (typeof value === 'object') return flatten(value.value || value.name || value.title || '');

    const raw = String(value).trim();
    if (!raw) return [];

    if ((raw.startsWith('[') && raw.endsWith(']')) || (raw.startsWith('{') && raw.endsWith('}'))) {
      try {
        return flatten(JSON.parse(raw));
      } catch (error) {
        return [raw];
      }
    }

    return raw
      .split(/[,;|\n]+/)
      .map((item) => item.trim())
      .filter(Boolean);
  }

  function dedupeLabels(values, shouldSort = true) {
    const map = new Map();
    values.forEach((value) => {
      const label = String(value || '').trim().replace(/\s+/g, ' ');
      const key = normalKey(label);
      if (label && !map.has(key)) map.set(key, label);
    });
    const labels = [...map.values()];
    return shouldSort ? labels.sort((a, b) => a.localeCompare(b, 'es', { numeric: true, sensitivity: 'base' })) : labels;
  }

  const modelSubmodelRules = [
    { model: /hilux/i, submodels: [/vigo/i, /revo/i, /gr\s*sport/i] },
    { model: /land\s*cruiser\s*prado|prado/i, submodels: [/serie\s*120/i, /serie\s*150/i, /serie\s*250/i, /kdss/i] },
    { model: /4\s*runner/i, submodels: [/3(?:ra|a)?\s*gen/i, /4(?:ta|a)?\s*gen/i, /5(?:ta|a)?\s*gen/i, /6(?:ta|a)?\s*gen/i, /sr5/i, /facelift/i] },
    { model: /fj\s*cruiser/i, submodels: [/serie\s*120/i] },
    { model: /fortuner/i, submodels: [/serie\s*50/i, /serie\s*60/i, /revo/i] },
    { model: /ranger/i, submodels: [/px/i, /pxiii/i, /next\s*gen/i, /t9/i] },
    { model: /bt[\s-]*50/i, submodels: [/px/i, /pxiii/i, /next\s*gen/i] },
    { model: /navara|np[\s-]*300/i, submodels: [/d40/i] },
    { model: /wrangler/i, submodels: [/jk/i, /jl/i] },
    { model: /gladiator/i, submodels: [/jt/i] },
    { model: /grand\s*cherokee/i, submodels: [/wk2/i] },
    { model: /jimny/i, submodels: [/3\s*puertas/i, /5\s*puertas/i] },
    { model: /silverado/i, submodels: [/trail\s*boss/i] },
    { model: /ram\s*1500|1500/i, submodels: [/classic/i, /\bds\b/i, /\bdt\b/i] },
    { model: /f[\s-]*150/i, submodels: [/raptor/i, /power\s*boost/i] },
  ];

  function submodelAppliesToModel(submodel, model) {
    const label = String(submodel || '');
    const matchingRules = modelSubmodelRules.filter((rule) => rule.model.test(model || ''));
    if (!matchingRules.length) return true;
    return matchingRules.some((rule) => rule.submodels.some((regex) => regex.test(label)));
  }

  function yearsFromValue(value) {
    const currentYear = new Date().getFullYear();
    const maxOpenYear = currentYear + 2;
    const years = new Set();

    flatten(value).forEach((entry) => {
      const text = String(entry || '').trim();
      if (!text) return;

      const open = text.match(/^(\d{4})\s*\+$/);
      if (open) {
        const start = Number(open[1]);
        for (let year = start; year <= maxOpenYear; year += 1) years.add(year);
        return;
      }

      const ranges = [...text.matchAll(/(\d{4})\s*[-–—]\s*(\d{4})/g)];
      if (ranges.length) {
        ranges.forEach((match) => {
          const start = Math.min(Number(match[1]), Number(match[2]));
          const end = Math.max(Number(match[1]), Number(match[2]));
          for (let year = start; year <= end; year += 1) years.add(year);
        });
        return;
      }

      const singles = text.match(/\d{4}/g);
      if (singles) singles.forEach((year) => years.add(Number(year)));
    });

    return [...years].filter(Boolean).sort((a, b) => b - a);
  }

  function readProducts(root) {
    const script = root.querySelector('[data-or-vehicle-products]');
    if (!script) return [];

    try {
      return JSON.parse(script.textContent || '[]')
        .map((product) => {
          const makes = dedupeLabels(flatten(product.make), false);
          const models = dedupeLabels(flatten(product.model), false);
          return {
            id: product.id,
            handle: product.handle,
            makes,
            models,
            entries: buildCompatibilityEntries(makes, models),
            submodels: dedupeLabels(flatten(product.submodel), false),
            years: yearsFromValue(product.year),
          };
        })
        .filter((product) => product.handle && product.entries.length);
    } catch (error) {
      console.warn('[or-vehicle-selector] Product data could not be parsed.', error);
      return [];
    }
  }

  function buildCompatibilityEntries(makes, models) {
    if (!makes.length || !models.length) return [];

    if (makes.length > 1 && models.length > 1 && makes.length === models.length) {
      return makes.map((make, index) => ({ make, model: models[index] })).filter((entry) => entry.make && entry.model);
    }

    return makes.flatMap((make) => models.map((model) => ({ make, model })));
  }

  function push(event, params) {
    window.dataLayer.push({
      event,
      ...params,
    });
  }

  function storageGet(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (error) {
      // Session persistence is optional.
    }
  }

  function storageRemove(key) {
    try {
      window.sessionStorage.removeItem(key);
    } catch (error) {
      // Session persistence is optional.
    }
  }

  function option(select, value, label) {
    const node = document.createElement('option');
    node.value = value;
    node.textContent = label;
    select.appendChild(node);
  }

  function resetSelect(select, label, disabled) {
    select.innerHTML = '';
    option(select, '', label);
    select.disabled = disabled;
  }

  function productMatches(product, makeKey, modelKey, submodelKey, year) {
    const hasVehicle = product.entries.some((entry) => normalKey(entry.make) === makeKey && normalKey(entry.model) === modelKey);
    const hasSubmodel = !submodelKey || !product.submodels.length || product.submodels.some((submodel) => normalKey(submodel) === submodelKey);
    const hasYear = product.years.includes(Number(year));
    return hasVehicle && hasSubmodel && hasYear;
  }

  function init(root) {
    const products = readProducts(root);
    const makeSelect = root.querySelector('[data-or-vehicle-make]');
    const modelSelect = root.querySelector('[data-or-vehicle-model]');
    const submodelField = root.querySelector('[data-or-vehicle-submodel-field]');
    const submodelSelect = root.querySelector('[data-or-vehicle-submodel]');
    const yearSelect = root.querySelector('[data-or-vehicle-year]');
    const applyButton = root.querySelector('[data-or-vehicle-apply]');
    const clearButton = root.querySelector('[data-or-vehicle-clear]');
    const result = root.querySelector('[data-or-vehicle-result]');
    const empty = root.querySelector('[data-or-vehicle-empty]');
    const actions = root.querySelector('[data-or-vehicle-actions]');
    const grid = document.querySelector('#product-grid');
    const items = [...document.querySelectorAll('[data-or-product-grid-item][data-or-product-handle]')];
    const collectionHandle = root.dataset.collectionHandle || '';
    const collectionTitle = root.dataset.collectionTitle || '';
    const storageKey = `orVehicleSelector:${collectionHandle}`;
    const openKey = `orVehicleSelectorOpen:${collectionHandle}:${window.location.pathname}`;

    if (!products.length || !makeSelect || !modelSelect || !submodelSelect || !yearSelect || !applyButton || !grid) {
      root.hidden = true;
      return;
    }

    const baseParams = () => ({
      collection_handle: collectionHandle,
      collection_title: collectionTitle,
    });

    const markOpen = () => {
      if (storageGet(openKey)) return;
      storageSet(openKey, '1');
      push('or_vehicle_selector_open', baseParams());
    };

    const allMakes = dedupeLabels(products.flatMap((product) => product.entries.map((entry) => entry.make)));
    allMakes.forEach((make) => option(makeSelect, normalKey(make), make));

    function selectedState() {
      return {
        makeKey: makeSelect.value,
        makeLabel: makeSelect.value ? makeSelect.selectedOptions[0]?.textContent || '' : '',
        modelKey: modelSelect.value,
        modelLabel: modelSelect.value ? modelSelect.selectedOptions[0]?.textContent || '' : '',
        submodelKey: submodelSelect.value,
        submodelLabel: submodelSelect.value ? submodelSelect.selectedOptions[0]?.textContent || '' : '',
        year: Number(yearSelect.value || 0),
      };
    }

    function updateModels() {
      const { makeKey } = selectedState();
      resetSelect(modelSelect, 'Seleccionar', true);
      resetSubmodels();
      resetSelect(yearSelect, 'Seleccionar', true);
      applyButton.disabled = true;

      if (!makeKey) return;

      const models = dedupeLabels(
        products
          .flatMap((product) => product.entries)
          .filter((entry) => normalKey(entry.make) === makeKey)
          .map((entry) => entry.model)
      );

      models.forEach((model) => option(modelSelect, normalKey(model), model));
      modelSelect.disabled = !models.length;
    }

    function resetSubmodels() {
      resetSelect(submodelSelect, 'Todos', true);
      submodelField.hidden = false;
    }

    function productsForVehicle(makeKey, modelKey) {
      return products.filter((product) =>
        product.entries.some((entry) => normalKey(entry.make) === makeKey && normalKey(entry.model) === modelKey)
      );
    }

    function updateSubmodels() {
      const { makeKey, modelKey } = selectedState();
      resetSubmodels();
      resetSelect(yearSelect, 'Seleccionar', true);
      applyButton.disabled = true;

      if (!makeKey || !modelKey) return;

      const modelLabel = modelSelect.selectedOptions[0]?.textContent || '';
      const submodels = dedupeLabels(
        productsForVehicle(makeKey, modelKey)
          .flatMap((product) => product.submodels)
          .filter((submodel) => submodelAppliesToModel(submodel, modelLabel))
      );

      submodels.forEach((submodel) => option(submodelSelect, normalKey(submodel), submodel));
      submodelSelect.disabled = !submodels.length;
      updateYears();
    }

    function updateYears() {
      const { makeKey, modelKey, submodelKey } = selectedState();
      resetSelect(yearSelect, 'Seleccionar', true);
      applyButton.disabled = true;

      if (!makeKey || !modelKey) return;

      const years = [
        ...new Set(
          productsForVehicle(makeKey, modelKey)
            .filter(
              (product) =>
                !submodelKey ||
                !product.submodels.length ||
                product.submodels.some((submodel) => normalKey(submodel) === submodelKey)
            )
            .flatMap((product) => product.years)
        ),
      ].sort((a, b) => b - a);

      years.forEach((year) => option(yearSelect, String(year), String(year)));
      yearSelect.disabled = !years.length;
    }

    function setFeedback(matches, state) {
      const vehicle = [state.makeLabel, state.modelLabel, state.submodelLabel, state.year].filter(Boolean).join(' ');
      const text = `${matches.length} ${matches.length === 1 ? 'producto compatible' : 'productos compatibles'} con ${vehicle}`;
      result.textContent = text;
      result.hidden = false;
      actions.hidden = false;
      empty.hidden = matches.length !== 0;
      grid.dataset.orVehicleFilterActive = 'true';
    }

    function clearFilter(pushEvent) {
      const state = selectedState();
      items.forEach((item) => {
        item.hidden = false;
      });
      delete grid.dataset.orVehicleFilterActive;
      result.hidden = true;
      actions.hidden = true;
      empty.hidden = true;
      storageRemove(storageKey);

      if (pushEvent) {
        push('or_vehicle_filter_clear', {
          ...baseParams(),
          vehicle_make: state.makeLabel || undefined,
          vehicle_model: state.modelLabel || undefined,
          vehicle_submodel: state.submodelLabel || undefined,
          vehicle_year: state.year || undefined,
        });
      }
    }

    function applyFilter(shouldPush) {
      const state = selectedState();
      if (!state.makeKey || !state.modelKey || !state.year) return;

      const matches = products.filter((product) =>
        productMatches(product, state.makeKey, state.modelKey, state.submodelKey, state.year)
      );
      const handles = new Set(matches.map((product) => product.handle));

      items.forEach((item) => {
        item.hidden = !handles.has(item.dataset.orProductHandle);
      });

      setFeedback(matches, state);
      storageSet(
        storageKey,
        JSON.stringify({ makeKey: state.makeKey, modelKey: state.modelKey, submodelKey: state.submodelKey, year: state.year })
      );

      if (shouldPush) {
        push('or_vehicle_filter_apply', {
          ...baseParams(),
          vehicle_make: state.makeLabel,
          vehicle_model: state.modelLabel,
          vehicle_submodel: state.submodelLabel || undefined,
          vehicle_year: state.year,
          matching_product_count: matches.length,
        });
      }
    }

    root.addEventListener('pointerdown', markOpen, { once: true });
    root.addEventListener('focusin', markOpen, { once: true });

    makeSelect.addEventListener('change', () => {
      markOpen();
      clearFilter(false);
      updateModels();
      const state = selectedState();
      if (state.makeKey) {
        push('or_vehicle_make_select', {
          ...baseParams(),
          vehicle_make: state.makeLabel,
        });
      }
    });

    modelSelect.addEventListener('change', () => {
      clearFilter(false);
      updateSubmodels();
      const state = selectedState();
      if (state.modelKey) {
        push('or_vehicle_model_select', {
          ...baseParams(),
          vehicle_make: state.makeLabel,
          vehicle_model: state.modelLabel,
        });
      }
    });

    submodelSelect.addEventListener('change', () => {
      clearFilter(false);
      updateYears();
      const state = selectedState();
      if (state.submodelKey) {
        push('or_vehicle_submodel_select', {
          ...baseParams(),
          vehicle_make: state.makeLabel,
          vehicle_model: state.modelLabel,
          vehicle_submodel: state.submodelLabel,
        });
      }
    });

    yearSelect.addEventListener('change', () => {
      clearFilter(false);
      const state = selectedState();
      applyButton.disabled = !state.year;
      if (state.year) {
        push('or_vehicle_year_select', {
          ...baseParams(),
          vehicle_make: state.makeLabel,
          vehicle_model: state.modelLabel,
          vehicle_submodel: state.submodelLabel || undefined,
          vehicle_year: state.year,
        });
      }
    });

    applyButton.addEventListener('click', () => applyFilter(true));

    clearButton?.addEventListener('click', () => {
      clearFilter(true);
      makeSelect.value = '';
      updateModels();
    });

    try {
      const saved = JSON.parse(storageGet(storageKey) || 'null');
      if (saved?.makeKey) {
        makeSelect.value = saved.makeKey;
        updateModels();
        modelSelect.value = saved.modelKey || '';
        updateSubmodels();
        submodelSelect.value = saved.submodelKey || '';
        updateYears();
        yearSelect.value = saved.year ? String(saved.year) : '';
        applyButton.disabled = !yearSelect.value;
        if (yearSelect.value) applyFilter(false);
      }
    } catch (error) {
      storageRemove(storageKey);
    }
  }

  roots.forEach(init);
})();
